import type { I18nFn } from '#/i18n/types/I18nFn';
import { getCountryName } from '#/utils/internationalization';

type AddressLocationParts = {
  city?: string | null;
  stateCode?: string | null;
  state?: string | null;
  country?: string | null;
};

export function getCityStateString(
  i18n: I18nFn,
  address: AddressLocationParts,
) {
  const stateOrCode = address.stateCode ?? address.state ?? null;
  const countryName =
    address.country && address.country !== 'US'
      ? getCountryName(i18n, address.country)
      : null;

  return [address.city, stateOrCode, countryName]
    .filter((part) => part)
    .join(', ');
}
